import './EmbedHome.module.scss'

// A project can be loaded by its original HTML or by the copied embed loader.
export function onEmbedReady(init) {
	const start = () => {
		const query = new URLSearchParams(window.location.search)
		// Only the standalone preview reads layout flags from its own URL.
		if (query.get('preview') === '1') {
			for (const container of document.querySelectorAll('[id^="app-"]')) {
				if (query.get('embed-home-column') === '1' && query.get('embed-home') === '1') container.dataset.embedHomeColumn = '1'
			}
		}
		init()
	}
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true })
	else start()
}
